<label
  class="inline-flex flex-col gap-2 justify-start items-start cursor-pointer text-on-surface dark:text-on-surface-darkmode text-sm leading-5"
>
  <div
    class="inline-flex gap-1.5 justify-center"
    [class.items-center]="alignToggle() === 'CENTER'"
    [class.items-start]="alignToggle() === 'TOP'"
  >
    <ng-content select="ui-toggle" />
    <span class="-mt-[3px]">
      <ng-content />
    </span>
  </div>
  <div class="empty:hidden text-sm/6">
    <ng-content select="ui-input-error,[slot=bottom]" />
  </div>
</label>
